import { EN_LOCAL_DATA } from '../../tdsHelper';
import { ISegmentConfigData, ITDSConfig } from './type';

export const hydrateFormData = (data: ITDSConfig): ISegmentConfigData => {
	const hydratedData: ISegmentConfigData = {} as ISegmentConfigData;
	hydratedData.segmentName = data.segmentName;
	hydratedData.weeklyCashbackLimit = data.weeklyCashbackLimit?.toLocaleString(EN_LOCAL_DATA);
	hydratedData.overallCashbackLimit = data.overallCashbackLimit?.toLocaleString(EN_LOCAL_DATA);
	return hydratedData;
};

export const dehydrateFormData = (data: ISegmentConfigData): ITDSConfig => {
	const conversionConfig: ITDSConfig = {} as ITDSConfig;
	conversionConfig.segmentName = data.segmentName;
	conversionConfig.weeklyCashbackLimit = Number(data?.weeklyCashbackLimit?.replace(/,/g, ''));
	conversionConfig.overallCashbackLimit = Number(data?.overallCashbackLimit?.replace(/,/g, ''));
	return conversionConfig;
};
